import { Building2, Component, PlusCircle, User, UserPlus } from "lucide-react"
import { Button, Card, Col, Placeholder, Row } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { useMemo } from "react"

import { useFetchUsersQuery } from "../../app/adminApiSlice"
import membershipPayable from "../../utils/membership/isMembershipPayable"
import { useFetchClubsQuery } from "../../app/clubsApiSlice"

const AdminDashboard = () => {
  const navigate = useNavigate()

  const { data: users, isSuccess: usersSuccess, isLoading: usersLoading } = useFetchUsersQuery()
  const { data: clubs, isSuccess: clubsSuccess, isLoading: clubsLoading } = useFetchClubsQuery()


  const handleCreateClub = () => navigate("/admin/clubs/create-club")

  const handleCreateAccount = () => navigate("/admin/members/create-account")

  const userEntries = useMemo(() =>
    users ? Object.entries(users) : []
    , [users])
    
  const membersCount = useMemo(() =>
    userEntries.length
    , [userEntries])

  const membershipsCompletedCount = useMemo(() =>
    userEntries.filter(([key, user]) => user.memberDetailsComplete).length
    , [userEntries])

  const clubsCount = useMemo(() =>
    clubs ? Object.entries(clubs).length : 0
    , [clubs])

  return (
    <>
      <h3 className="mb-4 text-start w-100 fw-bold">Admin Dashboard</h3>
      <div className="p-0 w-100">
        <Row className="g-4">
          <StatCard title="Total Accounts" icon={<User className="text-muted" />} isLoading={usersLoading || !usersSuccess} >
            {membersCount}
          </StatCard>
          <StatCard title="Membership Details Completed" icon={<Building2 className="text-muted" />} isLoading={usersLoading || !usersSuccess} >
            {membershipsCompletedCount} / {membersCount}
          </StatCard>
          <StatCard title="Total Clubs" icon={<Component className="text-muted" />} isLoading={clubsLoading || !clubsSuccess} >
            {clubsCount}
          </StatCard>
        </Row>

        {/* Quick Actions */}
        <Row className="mt-4">
          <Col sm={12}>
            <Card className="border-0 shadow-sm">
              <Card.Body className="">
                <p className="fs-5 fw-bold">Quick Actions</p>
                <div className="d-flex flex-column flex-sm-row gap-3 gap-sm-4">
                  <Button
                    className="d-flex text-white rounded-3 align-items-center justify-content-center shadow-0 border-0"
                    variant="dark"
                    onClick={handleCreateClub}
                    style={{ minWidth: "200px" }}
                  >
                    <PlusCircle size={20} className="me-2" /> <span className="fs-7 me">Create New Club</span>
                  </Button>
                  <Button
                    className="d-flex text-white rounded-3 align-items-center justify-content-center shadow-0 border-0"
                    variant="dark"
                    onClick={handleCreateAccount}
                    style={{ minWidth: "200px" }}
                  >
                    <UserPlus size={20} className="me-2" /> <span className="fs-7 me">Create New Account</span>
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

      </div>

    </>
  )
}

export default AdminDashboard

const StatCard = ({ title, children, icon, isLoading }) => {
  if (isLoading) {
    return (
      <Col xl={3} lg={6} sm={6} xs={12}>
        <Card className="border-0 shadow-sm p-1">
          <Card.Body className="d-flex justify-content-between align-items-center">
            <div className="w-100 opacity-25">
              <Placeholder as={Card.Title} animation="glow" className="fs-7 mb-2">
                <Placeholder xs={7} />
              </Placeholder>
              <Placeholder as={Card.Text} animation="glow" className="fw-bold fs-5">
                <Placeholder xs={5} />
              </Placeholder>
            </div>
            <div className="placeholder-glow opacity-25">
              <Placeholder className="rounded" style={{ width: '24px', height: '24px' }} />
            </div>
          </Card.Body>
        </Card>
      </Col>
    )
  }

  return (
    <Col xl={3} lg={6} sm={6} xs={12}>
      <Card className="border-0 shadow-sm p-1">
        <Card.Body className="d-flex justify-content-between align-items-center">
          <div>
            <Card.Title className="fs-7 text-muted">{title}</Card.Title>
            <Card.Text className="fw-bold fs-5">{children}</Card.Text>
          </div>
          {icon}
        </Card.Body>
      </Card>
    </Col >
  )
}